import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=1a4a4fb5"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=1a4a4fb5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4a4fb5')) {
      api.createRecord('1a4a4fb5', component.options)
    } else {
      api.reload('1a4a4fb5', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=1a4a4fb5", function () {
      api.rerender('1a4a4fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/Form.vue"
export default component.exports